// Autogenerated file
export const unitOfMeasuresEnum = {
    None: "None",
    Piece: "Piece",
    Kilogram: "Kilogram",
    Gram: "Gram",
    Tonne: "Tonne",
    Litre: "Litre",
    Millilitre: "Millilitre",
    Meter: "Meter",
    Centimeter: "Centimeter",
    Millimeter: "Millimeter",
    LinearMeter: "LinearMeter",
    SquareMeter: "SquareMeter",
    CubicMeter: "CubicMeter",
    Package: "Package",
    Box: "Box",
    Bottle: "Bottle",
    Can: "Can",
    Pack: "Pack",
    Set: "Set",
    Pair: "Pair",
    Hour: "Hour",
    Minute: "Minute",
    Day: "Day",
    Month: "Month",
    Year: "Year",
    ConditionalUnit: "ConditionalUnit",
    HorsePower: "HorsePower",
};
export const unitOfMeasures = [
    { label: "Не указан", value: "None" },
    { label: "шт", value: "Piece" },
    { label: "кг", value: "Kilogram" },
    { label: "г", value: "Gram" },
    { label: "т", value: "Tonne" },
    { label: "л", value: "Litre" },
    { label: "мл", value: "Millilitre" },
    { label: "м", value: "Meter" },
    { label: "см", value: "Centimeter" },
    { label: "мм", value: "Millimeter" },
    { label: "пог. м", value: "LinearMeter" },
    { label: "кв. м", value: "SquareMeter" },
    { label: "куб. м", value: "CubicMeter" },
    { label: "уп", value: "Package" },
    { label: "кор", value: "Box" },
    { label: "бут", value: "Bottle" },
    { label: "бан", value: "Can" },
    { label: "пач", value: "Pack" },
    { label: "компл", value: "Set" },
    { label: "пар", value: "Pair" },
    { label: "час", value: "Hour" },
    { label: "мин", value: "Minute" },
    { label: "дн", value: "Day" },
    { label: "мес", value: "Month" },
    { label: "г", value: "Year" },
    { label: "усл. ед.", value: "ConditionalUnit" },
    { label: "л.с.", value: "HorsePower" },
];
